import React from "react";
import { useSelector } from "react-redux";

const FileUploader = React.forwardRef(
  (
    {
      onFileSelectSuccess,
      onFileSelectError,
      fileSize = 20971520, // 20 MB
      fileFormat = false,
    },
    ref
  ) => {
    React.useEffect(() => {}, []);

    const fileInput = null;
    const genericheTranslation = useSelector(
      (state) => state.translations.generiche
    );
    const sizeFileError =
      genericheTranslation.sizefileerror.itemName.toUpperCase();
    const typeFileError =
      genericheTranslation.typefileerror.itemName.toUpperCase();

    const handleFileInput = (e) => {
      // handle validations
      const file = e.target.files[0];
      const filename = file.name;
      const fileextension = filename.split(".").pop().toLowerCase();
      const iConvert = (fileSize / 1048576).toFixed(2);
      if (file.size > fileSize)
        onFileSelectError({
          error: sizeFileError + iConvert + "MB",
        });
      else if (!fileFormat.includes("." + fileextension))
        onFileSelectError({ error: typeFileError });
      else onFileSelectSuccess(file);
    };

    return (
      <div className="file-uploader my-3">
        <input
          autoComplete="off"
          className=""
          type="file"
          onChange={handleFileInput}
        />
        <button
          onClick={(e) => fileInput.current && fileInput.current.click()}
          className="btn btn-primary"
        ></button>
      </div>
    );
  }
);

export default FileUploader;
